import { useEffect, useState } from "react";

const useLOData = (agentName) => {

    //console.log(agentName,"lopath check")
    const [loData, setLoData] = useState(null);

    const path = process.env.REACT_APP_CDN_LOANOFFICER_JSONS;
    //console.log(path, "Darshan")

    const fetchData = async () => {
        try {
            // console.log(path + agentName + ".json", "json path to check")
            const data = await fetch(path + agentName + ".json");
            const jsonData = await data.json();
            setLoData(jsonData);
            // console.log(jsonData,"Json Data print");
        } catch (error) {
            // window.location.replace(process.env.PUBLIC_URL);
        }
    }

    useEffect(() => {
        fetchData();
    }, [agentName]);

    return loData;
}

export default useLOData;